module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "center",
    attrs: {
      "id": "chap13"
    }
  }, [_vm._v("10. The Scarab")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('i', [_vm._v("An Egyptian stone beetle and great secret scarab stuffed with the first arms for the future Jewish underground army.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EARLY THREE THOUSAND YEARS")]), _vm._v(" later in 1920, young O’Sullivan Beare was far from being ready to retire. As soon as he entered the Home for Crimean War Heroes he began to scheme, looking for ways to make money, hinting in various Arab coffee shops that he had extensive experience in illegal affairs. Before long a man of indeterminate nationality approached him.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Smuggling arms? He nodded. He described his four years on the run in southern Ireland and the man seemed impressed. From where to where? Constantinople to here. For whom? The Haganah. What’s that? The future Jewish underground army. Who’s it going to fight, the English? If necessary. Good, bloody English.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("You’ll have the honor of bringing them their first weapons, added the man. If the money is right, thought Joe.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Money. He remembered Haj Harun’s lost treasure map, which he was sure existed. The old Arab had referred to it only in passing as "), _c('i', [_vm._v("the story of my life,")]), _vm._v(" but Joe had been too intrigued to let the matter rest there.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("You wrote it down? he’d asked Haj Harun.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The old Arab had waved his arms in circles. He couldn’t remember whether he had or not but to Joe the implication was that he had and later lost or misplaced it, this real or secret history of the riches he’d discovered in the caverns beneath Jerusalem, in the Old Cities he’d explored down there and then mixed up in his mind with tales from the "), _c('i', [_vm._v("Thousand and One Nights")]), _vm._v(" and the other fancies that obsessed him, a detailed guide to the incalculable wealth brought to Jerusalem over the millennia by conquerors and pious fanatics.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He’d pressed Haj Harun about it.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Are you sure you don’t have any idea what you could have done with it?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("With what?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The story of your life.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Haj Harun had shrugged helplessly and wrung his hands, certainly wanting to please his new friend by recalling this or anything else yet simply unable to, his memory slipping as he said and the years all sliding together, pumping his arms in circles and sadly admitting he just couldn’t be sure, just couldn’t say, the past was too confusing.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Was he forgiven? Were he and Prester John still friends?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("That they were, Joe had answered, nothing changed that. But the treasure map had never left his mind and now he wondered whether to mention it to his new employer, who seemed to know a good deal about Jerusalem. Why not chance it? Carefully, without enthusiasm, he asked the man if he had ever heard of a document that supposedly included three thousand years of Jerusalem’s history, written by a madman and worthless, thought to have disappeared not too long ago.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The man studied him curiously. Was he referring to the myth of an original Sinai Bible? An original version totally unlike the forgery later bought by the czar?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_c('i', [_vm._v("The czar. Even the czar had been after it. So eager to get his hands on the map he’d been going around snapping up forgeries.")])]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("That’s it. What do they say happened to it?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Supposedly it was buried. But no one has ever seen it and of course it’s all nonsense, the fabrication of a demented mind.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Demented certainly, nonsense of course, buried assuredly. Haj Harun unlocking his antique safe one evening and putting a foot on the ladder, a short time later padding stealthily away down a tunnel fifty feet below the ground for a long private night in the caverns.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("What do they say was in it exactly?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The man smiled. That’s the point. Supposedly everything is in it.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_c('i', [_vm._v("Everything.")]), _vm._v(" Persian palaces and Babylonian tiaras and Crusader caches, Mameluke plunder and Seleucid gold. A map so valuable the czar had been willing to trade his empire for it.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("When do they say it was buried?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("In the last century.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Yes that would be right, Haj Harun would still have had his wits about him then. He’d have written it and hidden it and then forgotten where he’d hidden it when he was seized by the idea of his holy mission. He saw the old man stumbling around the walls of his empty shop staring into corners. Mission to where? The moon. Residence? Lunacy. Occupation? Lunatic.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Jaysus that was his Haj Harun all right. Explorer of secret caverns and discoverer of two dozen Old Cities, mapmaker of the centuries, the former King of Jerusalem now reduced to peering at blank walls and absentmindedly adjusting his helmet, which released a shower of rust to fill his eyes with tears and blur the figure he’d hoped to see in his nonexistent mirror.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The man on the other side of the table was talking about routes from Constantinople. Trails, roads, paths, English border posts and sentries, defiles to be crossed at night. Joe held up his hand.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Here now, aren’t we talking about the first arms ever to be smuggled to the Haganah? What’s an everyday wagon with a false bottom doing on such an occasion? Figs for cover? I have a better idea. There’s a giant stone scarab I happen to know about, hollow inside so that it could hold a lot. A scarab, I said. A giant Egyptian stone scarab.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The man gazed at him. Joe lowered his voice.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Picture it now. From the heart of the enemy’s camp a huge beetle inches across an ancient parched homeland one day to be fertile again. A relentless scarab creeping forward, an Egyptian scarab as patient and hard as stone because it is stone as still stone. A scarab as old as the pyramids, as determined as the people who will now escape those pyramids, a giant stone scarab scaling the slopes of the mountain to reach Jerusalem at last in the first light of a new day, an Egyptian stone beetle and great secret scarab stuffed with the first arms for the future Jewish underground army.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("O’Sullivan Beare leaned back and smiled, suspecting this man Stern might pay him well.")]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("He had the baking priest’s papers and Stern’s instructions, now all he had to do was get Haj Harun to agree to the trip, since there was no hope of parting him from the scarab. This morning, he said, I overheard someone mention a man named Sinbad. Who is he anyway? A local trader?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Haj Harun abruptly stopped pacing along the walls.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("A local trader? Do you mean you’ve never heard of Sinbad’s mighty adventures?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("No. What were they then?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Haj Harun took a deep breath and launched into a headlong account. Twenty minutes passed before the sundial chimes struck, causing him to pause.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Midnight though the sun’s out, said Joe. When was the last time you went to sea?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Haj Harun’s hands hung in midair.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("What?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("To sea.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Who?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("You yourself.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Me?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Yes.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Haj Harun lowered his head in embarrassment.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("But I’ve never been to sea. I’ve never left Jerusalem except to make my annual haj.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The hell you say. Sinbad did all that and you’ve never been to sea even once?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Haj Harun covered his face, overwhelmed by the pathetic failure of his life. His hands shook, his voice quivered.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("It’s true. How can I ever make up for it?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Why we’ll make a trip of course. We’ll follow resolutely in the wake of Sinbad.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I can’t. I can’t leave my treasures unprotected.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("No need to. No one can make off with the safe, it’s too heavy or too deeply rooted or both. Your helmet you can wear, Sinbad probably wore one himself. And the scarab we’ll take with us.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("We will? Would a ship captain allow it?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("We’ll tell him it’s cargo. We’ll say we’re in the antiquities business and we’re lugging it to Constantinople to sell for some lighter pieces. He’ll understand. Who wants to own something that heavy? Then when we come back we’ll say we couldn’t get a proper price for it, all neat and tidy and no one suspecting a thing. What do you say?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Haj Harun smiled dreamily.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Resolutely in the wake of Sinbad? After all these years?")]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("The same afternoon the sea voyage was proposed Haj Harun noticed something that bewildered him. All at once his new friend had begun to refer to his past as a Bible. More specifically he called it the Sinai Bible.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("What did it mean? Why was his past a Bible to his friend and what did it have to do with the Sinai? Was he being accepted as Moses’ spiritual companion and brother in the wilderness because his name was Aaron?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He pondered the problem as best he could and kept returning to Moses. After forty years of wandering Moses had arrived somewhere, and although he had been wandering about seventy-five times that long he hadn’t gotten anywhere at all yet. But in the near future? Did his friend have faith in the eventual success of his mission? Was that what he was saying?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Haj Harun peeked shyly at the crumbling plaster in his nonexistent mirror. He straightened his helmet.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Was it blasphemous? Should he accept this new information as he had accepted so many apparently incomprehensible truths over the centuries?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Humbly he agreed it was his duty. His friend was insistent and he couldn’t turn away from facts just because they seemed unlikely. Facts had to be believed. Although he had never suspected it until this moment, he, Haj Harun, was the secret author of the Sinai Bible.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("And once having accepted it as fact he easily fitted it into his background. That very evening he was referring to the Sinai Bible as his diary, an account of adventures recorded in the course of a Jerusalem winter during some earlier epoch of his life.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("By epoch you mean the last century? asked O’Sullivan Beare.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Haj Harun smiled, he nodded. He couldn’t quite recall why he had written down what he had, but probably it had been to pass the time and forget the icy drafts in the caverns where it was likely he had been living then.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Why this likelihood? asked O’Sullivan Beare.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Haj Harun looked doubtful, then laughed.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Because the caverns have been my winter residence as far back as I can remember.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("They have? Then you admit the Sinai Bible deals solely with what you found in the caverns?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Oh yes indeed, answered the old man grandly. Didn’t you know that’s been my routine for some time now? Wandering around the Judean hills in the summer enjoying the sunshine, back to my shop and the streets of the Old City for the brisk clear air of autumn, the caverns of the past in winter and a haj in the spring? I’ve kept to that schedule for millennia and why not? What could be more exhilarating?")]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("The morning they were due to leave O’Sullivan Beare was locking up the safe when he noticed a small piece of paper caught in a crevice at the back. He pulled it out and passed it to Haj Harun.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("A reminder you wrote yourself before the Crusaders arrived?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Not mine. It’s a letter in French.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Can you read it?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Of course.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Well who’s it to then?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Someone named Strongbow.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Bloody myth, muttered O’Sullivan Beare, who had heard stories about the nineteenth-century explorer in the Home for Crimean War Heroes. Never existed. Couldn’t. No Englishman was ever that daft. What’s it say?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("It thanks this man Strongbow for a present he sent across the Sahara in honor of a special occasion.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("What’s the present?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("A pipe of Calvados.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("All that way and only a pint?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("No, pipe, a kind of measurement I believe. About one hundred and fifty gallons. Say about seven hundred bottles.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("And why not, might as well say that as anything else. What’s the special occasion?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The birth of his nine hundredth child.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Do you say so. Whose nine hundredth child?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The man who wrote the letter.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("How’s he sign himself?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Father Yakouba.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Oh I see, a priest. Where’s he writing from?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Timbuktu.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("What?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("That’s all there is except the number on the letter. They must have had a large correspondence.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Why this opinion?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The number is four thousand and something. The script is faded there.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Well Jaysus it should be. A priest fathering nine hundred children? Seven hundred bottles of Calvados marching to Timbuktu? Four thousand letters each way? What’s the date on it?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Midsummer night, 1840.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("What were you doing then?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Haj Harun looked puzzled.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Never mind. At least you weren’t tramping around the Sahara boiling your brains in the sun. Come on, here comes the cart for the scarab.")]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("Sinbad’s hour arrived. In Jaffa they boarded a Greek caïque and a course was set for southern Turkey. Haj Harun was sick from the beginning, unable to go below decks because of the engine fumes and unable to keep his balance topside because he was so weak from vomiting. He was afraid the waves would wash him overboard and eventually O’Sullivan Beare had to lash him to the gunwale beside the scarab to keep him from tumbling around and hurting himself.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The Irishman crouched astride the scarab holding its ropes like reins, riding it backward to Constantinople. The boat pitched violently. As each new wave broke over the bow Haj Harun clenched his jaw and closed his eyes. The waves smashed down, his body writhed, a stream of water shot out of his mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("How many? shouted O’Sullivan Beare.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("How many what? groaned Haj Harun.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Like I said, how many others know about the Sinai Bible?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The bow of the boat sank out of sight, a wall of water loomed in the sky. Haj Harun pressed himself against the gunwale in terror. The sea swept over them with a roar and the boat began to climb.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("What did you say?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Two or three.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("That’s all?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("At any given moment, but after all we’re talking about three thousand years of moments.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Jaysus.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Haj Harun screamed. A new wave rose majestically. Haj Harun turned his head.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("How many does that add up to all together then?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Twelve?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Only twelve?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("More or less.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("But that’s nothing at all.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I know it’s nothing. Could the number have something to do with the moon or the tribes of Israel?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Are you sure only twelve more or less?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Haj Harun wanted to be brave. If he had been standing on solid ground in Jerusalem he would have straightened his shoulders at least a little and pushed back his helmet and fixed his gaze on the domes and towers and minarets of his beloved city. But here he was helpless.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Yes, he whispered, trembling and ashamed. Then once again he tried to be hopeful as he had by invoking and aligning himself with the twelve tribes and the moon.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("There’s an old saying that there are only forty people in the world and we get to know only a dozen of them in our lifetime. Might that explain it?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("O’Sullivan Beare nodded solemnly as if weighing this information. It might explain the moon and lunacy but not much else.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I’ve heard that saying, he shouted, but does it apply to a life as long as yours? I mean if you’ve lived three thousand years how can so few people have known you?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Not quite three thousand, whispered Haj Harun. I’m sixteen years short of that.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("All right, not quite three thousand. Now who are these dozen people? Emirs and patriarchs? Chief rabbis? Princes of the church? People like that?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Oh no, whispered Haj Harun.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Well who?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Do you remember that man who walks back and forth on the top of the steps that lead down to the crypt in the church?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The Church of the Holy Sepulchre? The one who never stops? The one who’s always muttering to himself? The man you said has been doing that for the last two thousand years?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Yes that’s him. Well he believes me. Or at least he didn’t beat me when I told him about it.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Did he stop walking back and forth?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("No.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Stop muttering to himself?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("No.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Did he even look at you?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Haj Harun sighed. No.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("All right, who else then?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("There was a cobbler once. I went into his cubbyhole and told him about it and he didn’t beat me either.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Where was that?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Somewhere in the Old City.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Where?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I can’t quite recall.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("When?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I don’t remember.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Who else?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I can’t think of anyone else but it may come to me.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Beautiful, thought the Irishman, just no competition at all. The map’s there for the taking.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("By Jaysus is that the truth? he shouted.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Oh God the truth, moaned Haj Harun as the boat shot down and down, as a monstrous wave leapt into the sky and he turned his head to receive the vicious blow on his other cheek.")]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("The day they docked in Constantinople the stomach of the stone scarab was tightly packed with dismantled Czech rifles. The return voyage was just as rough and by the time they arrived Haj Harun had gone without food for three weeks. In Jaffa the heavy scarab was lowered off the boat into a cart. There was little traffic on the pier and the English customs official seemed to want to pass the time.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Couldn’t make a sale up there?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Not offered enough this trip but next time we’ll make it.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The official was staring at Haj Harun, at the rusting helmet that kept crashing down on his nose. The old man was walking in circles, anxious to finish the last stage of the journey.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Who is he? whispered the official. I mean who does he think he is?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He doesn’t think, he knows. He’s the last King of Jerusalem.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The what?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("That’s right.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("And the scarab’s his?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Yes.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Where’d he get it?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("From the former king.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("And when was that?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The twelfth century I think. He’s not too good on dates, uniforms either.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The official smiled and picked up his pen.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Name?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("MacMael n mBo, baking priest.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Permanent place of residence, Mr. Priest?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The Home for Crimean War Heroes, Jerusalem.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Nationality?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Crimean.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Status of traveler?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Retired war hero.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Present occupation?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Keeper of the royal scarab, second class.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The customs official smiled but O’Sullivan Beare’s face was serious. He was having difficulty holding Haj Harun, who seemed ready to walk off the side of the pier at any moment.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Expect you’ll be seeing a promotion soon?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Within the decade probably.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Fine. Now just point the old man in this direction so I can ask him a question or two.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I wouldn’t, not if you want to keep your sanity.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The official laughed.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Name? Residence? Profession?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Haj Harun muttered his name, then repeated "), _c('i', [_vm._v("Jerusalem")]), _vm._v(" three or four times.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("How’s that? Profession?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Jerusalem, said Haj Harun.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("That’s a profession?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("For him it is.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Now listen, just have him tell me something he’s done in his life. Anything at all, I don’t care, I just want to fill out this form.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Go ahead and tell him then, said Joe.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Indeed I will, answered Haj Harun. Once I wrote the Sinai Bible.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The what?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The Bible. I’m sure you’ve heard of it.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Well that’s just lovely. And what, my friend, is the Sinai Bible?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The original Bible, whispered Joe. I mean it’s the oldest one that’s ever been found only now it’s lost again. He misplaced it.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The customs official swore.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Who misplaced it?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("This Arab here called Aaron. The man who wrote it.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Get your arses off my pier, shouted the official.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("O’Sullivan Beare nodded pleasantly. He bent and heaved, Haj Harun broke into a wheezing cough. Pushing and pulling they wheeled the heavy cart with its secret load of weapons down the quay, gathered momentum midway and had to run to keep up as the giant stone beetle went hurtling into the Holy Land.")]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("The next day they were trudging up the heights toward Jerusalem in a cloudbank. They climbed in silence beside the cart, Joe prodding the donkey and Haj Harun struggling along behind. Toward the end of the afternoon Haj Harun spoke for the first time.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("It’s my last trip.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Why this sentiment?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("No food in three weeks. I’m sick.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("And Sinbad and all the voyages he made? You can’t forget that can you and just give up?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("No I guess I can’t. It’s true there’s much to bear and we have to keep trying.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("His chin fell to his chest, slamming the helmet into his nose. There was little light from the overcast sky and his eyes were watering as usual so he was having trouble finding the path. For several hours he had been straying off into the wastes stumbling over rocks and bushes. His hands were scratched and cut, he limped from a bruised knee on one leg and a sprained ankle on the other. Blood oozed out of a jagged gash in his cheek.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The cold wind ripped at them. Joe plodded along with his head down. All at once there was a loud crash. The donkey stopped, Joe went back down the path to see what had happened.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Haj Harun lay stretched on the ground on his face next to a tall narrow boulder. He had walked over it blindly, one foot on each side, or rather he would have walked over it if the boulder hadn’t been waist-high. The rock had smashed into his groin tearing muscles and cracking bones. He had lost his balance and fallen on his head twisting a leg as he went down. Only his helmet, newly dented down the middle, had saved him from crushing his skull.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Joe rolled him over. One leg looked broken and the entire pelvic region was soaked in blood. He groaned and lay still.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("That’s it, I can’t take any more, you might as well go on without me.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The leg?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Numb, it won’t move, I can’t move, my insides are all torn apart. For centuries I’ve been trying to do it, trying to go on, but this time it’s over, I’m finished and I know it. I’m too old and tired, just a miserable sack of pains, nothing but aches and more aches, no I can never move again. Oh I know you thought you could help and you did but I’m beyond helping now, I’ve reached the very end. There’s a limit after all, sadly there is. So take the kingdom, Prester John, it’s yours, and take the scarab and the safe and the sundial, they’re yours too. You know, I used to think I’d have no regrets when the end came but now I know I’m no match for Sinbad and all those other people I dreamed about, no match for anyone at all. Once I thought I could do something but it never worked out. That cobbler and that man on the top of the steps who doesn’t even know I’m there, they’re the only ones who will listen to me, you’re right about that. Other people just beat me, they always have. They beat me because I’m foolish. They call me a fool and I know I am. Just an old fool who has never done anything, never accomplished one thing, nothing at all.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Stop this now, said Joe. Stop it right here. The city depends on you, it’s survived because of you. Where would it be without you to defend it? Who would rebuild it? How would it keep growing higher? What would happen to the caverns?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Haj Harun sobbed quietly.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("No, I wanted to think all those things but they’re not true. You know my wives were probably right after all, I should have been content to live like other people. I was comfortable, there was more than enough to eat and I was never cold, and since then I’ve done nothing but starve and shiver and never sleep, never get any rest at all because my gums hurt so much when I lie down. And they warned me, I don’t deny it. Don’t be a fool, they said. Why give up everything for this hopeless mission? Do you want to be cold all the time? Do you want to starve? You must be mad.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Haj Harun’s crumpled figure was all but lifeless. He lay on the stony ground gasping painfully for breath, his face smeared with blood. Blood and rust filled his eyes. The circle of blood below his waist was spreading. The broken leg was bent awkwardly to one side.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Joe knelt holding the old man’s hands, which were so cold it frightened him. His pulse was uneven and growing weaker.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("It couldn’t be. Was the old warrior really dying?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("A sudden warmth fell on his shoulders. He looked up. The sky had opened and a fierce wind was peeling the clouds back over the hills. Directly above them, lit by the sun, was Jerusalem.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Look, he shouted.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Haj Harun’s lips moved. There was a gurgle deep in his throat.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("It’s no use, I can’t see. I tried and failed and it’s over.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("No, look.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He gathered Haj Harun up in his arms and wiped the blood and rust out of his eyes. The old man’s head rolled back. He gasped.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_c('i', [_vm._v("Jerusalem.")])]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Yes.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Right there.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Yes.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Haj Harun struggled out of his arms. He crawled to his knees and planted one foot. He grasped the boulder and pulled himself up never taking his eyes off the mirage above him. Wildly he lurched away from the boulder, slipped and nearly fell but somehow kept going, staggering and coughing and spitting, cackling and stumbling, half naked on his spindly crooked legs tottering up the hillside, laughing and trailing blood and no longer caring whether he was on the path or not, waving his arms frantically as he yelled.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_c('i', [_vm._v("I’m coming, wait I’m coming.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24ff7405","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v1/21-chap13.vue
// module id = 132
// module chunks = 0